<script setup lang="ts">
import { useAppStore } from '@/store'
import { generateSafeRedirectUrlFn, local } from '@/utils'

const router = useRouter()
const appStore = useAppStore()

const name = import.meta.env.VITE_APP_NAME
</script>

<template>
  <a
    v-track="{ type: 'SuperLink', public: true }"
    class="h-60px flex items-center cursor-pointer gap-2 pl-20px lt-md:text-4 text-xl"
    :class="[{ '!pl-0 justify-center': appStore.collapsed }]"
    @click.stop.prevent="generateSafeRedirectUrlFn('https://www.seaarea.com/')"
    title="前往海域云官网"
  >
    <!-- <svg-icons-logo class="text-1.5em" /> -->
    <svg-icons-logo2025 class="w-40px h-40px lt-md:w-30px" />
    <span
      v-show="!appStore.collapsed"
      class="text-ellipsis overflow-hidden whitespace-nowrap "
    >海域云会员中心</span>
  </a>
</template>

<style scoped></style>
